"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

import IntercomTracker from "@/components/analytics/intercom-tracker";
import { PosthogProvider } from "@/components/analytics/posthog-provider";
import useGoogleTagManager from "@/components/analytics/use-google-tag-manager";
import useSentryTracker from "@/components/analytics/use-sentry-tracker";

export default function ClientProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  useGoogleTagManager();
  useSentryTracker();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <PosthogProvider>
        <IntercomTracker>{children}</IntercomTracker>
      </PosthogProvider>
    </QueryClientProvider>
  );
}
